import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export let lenis, scrollToStart, autoScroll

export const lenisScroll = () => {

	lenis = new Lenis({
		duration: 0.9,
		anchors: {
			offset: -118,
			duration: 1.8,
		}
	})

	lenis.on('scroll', ScrollTrigger.update())

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)

		if (lenis.scroll > 5) {
			document.documentElement.dataset.scrolled = true
		} else {
			document.documentElement.dataset.scrolled = false
		}

		if (lenis.scroll > window.innerHeight) {
			document.documentElement.dataset.scrolledViewport = true
		} else {
			document.documentElement.dataset.scrolledViewport = false
		}

		if (lenis.direction == 1 && lenis.scroll > 0) {
			document.documentElement.dataset.direction = 'forward'
		} else {
			document.documentElement.dataset.direction = 'backward'
		}
	}

	requestAnimationFrame(raf)

	document.addEventListener('wheel', (e) => {
		const scrollArea = e.target.closest('.CybotCookiebotScrollArea')
		if (scrollArea) {
			e.stopPropagation()
		}
	}, { passive: false })

	document.addEventListener('touchmove', (e) => {
		const scrollArea = e.target.closest('.CybotCookiebotScrollArea')
		if (scrollArea) {
			e.stopPropagation()
		}
	}, { passive: false })

}

scrollToStart = () => {
	lenis.scrollTo(0, { immediate: true })
}

autoScroll = (hash) => {
	if (!lenis || !hash) return

	if (!hash.startsWith('#')) hash = `#${hash}`

	const target = document.querySelector(hash)
	if (target) {
		lenis.scrollTo(target, {
			offset: -118,
			duration: 1.8,
		})
	}
}

export default () => { }
